var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPaymentVisa = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  id: "payment_visa_svg__Layer_1",
  "data-name": "Layer 1",
  viewBox: "174.34 421.63 731.33 236.72"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".payment_visa_svg__cls-2{stroke-width:0;fill:#00579f}"))), /*#__PURE__*/React.createElement("path", {
  id: "payment_visa_svg__path17",
  d: "M270.63 425.79h-95.31l-.98 4.62c74.34 19.01 123.55 64.84 143.82 119.93l-20.72-105.29c-2.63-12.37-14.25-20.72-26.81-19.26Z",
  style: {
    strokeWidth: 0,
    fill: "#faa61a"
  }
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "payment_visa_svg__polygon9",
  className: "payment_visa_svg__cls-2",
  d: "M491.24 654.82H432l37.05-229.1h59.24l-37.05 229.1Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  id: "payment_visa_svg__path11",
  className: "payment_visa_svg__cls-2",
  d: "M705.95 431.39a146.008 146.008 0 0 0-53.13-9.76c-58.5 0-99.69 31.19-99.95 75.8-.48 32.91 29.49 51.19 51.92 62.15 22.91 11.23 30.71 18.53 30.71 28.53-.24 15.34-18.52 22.46-35.57 22.46-19.24.54-38.33-3.64-55.58-12.18l-7.8-3.66-8.3 51.43c21.06 8.17 43.47 12.3 66.06 12.19 62.16 0 102.69-30.71 103.09-78.24.24-26.07-15.6-46.07-49.74-62.39-20.72-10.48-33.41-17.55-33.41-28.27.24-9.76 10.73-19.74 34.11-19.74 15.18-.44 30.27 2.56 44.13 8.78l5.36 2.44 8.02-49.47.06-.08Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  id: "payment_visa_svg__path13",
  className: "payment_visa_svg__cls-2",
  d: "M784.69 573.72c4.81-13.16 23.65-64.1 23.65-64.1-.24.48 4.81-13.4 7.8-21.93l4.14 19.74s11.23 54.84 13.66 66.29l-49.25.02Zm73.12-147.94h-45.83c-13.49-1.63-26.32 6.25-30.97 19.01l-87.98 210.03h62.23l12.44-34.37h76.06c1.7 8.02 7.06 34.37 7.06 34.37h54.85l-47.79-229.09-.06.05Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  id: "payment_visa_svg__path15",
  className: "payment_visa_svg__cls-2",
  d: "m382.48 425.79-58.01 156.22-6.42-31.69a175.338 175.338 0 0 0-81.83-96.03l53.14 200.35h62.58l93.07-228.85h-62.58.05Z"
})));
export default SvgPaymentVisa;